import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AuthInterceptor } from '@app/interceptors/auth.interceptor';
import { FollowModule } from '@app/modules/follow/follow.module';
import { SupplierPortalModule } from "@app/modules/supplier-portal/supplier-portal.module";
import { FlashComponent } from '@core/components/flash/flash.component';
import { FooterComponent } from '@core/components/footer/footer.component';
import { HeaderComponent } from '@core/components/header/header.component';
import { ModalQueryFilter } from '@core/components/modal-query-filter/modal-query-filter.component';
import { LayoutComponent } from '@core/containers/layout/layout.component';
import { effects } from '@core/effects';
import { reducers } from '@core/reducers';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressHttpModule } from '@ngx-progressbar/http';
import { NgDragDropModule } from 'ng-drag-drop';
import { CookieService } from 'ngx-cookie-service';
import { ProductDisabledFobComponent } from '../proformaUI/containers/product-disabled-fob/product-disabled-fob.component';
import { ProformaWeightedFobModalComponent } from '../proformaUI/containers/proforma-weighted-fob-modal/proforma-weighted-fob-modal.component';
// import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { FollowIdComponent } from "../supplier-portal/components/followId-confirmation/followId-confirmation.component";

import { AuthActionTypes } from '@core/actions/auth.actions';
import { storeLogger } from 'ngrx-store-logger';

export function logger(reducer: any): any {
  return storeLogger()(reducer);
}

const metaReducers = [];

function clearState(reducer) {
  return function(state, action) {
    if (action.type === AuthActionTypes.LogoutSuccess) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

//metaReducers.push(logger);
metaReducers.push(clearState);

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    BrowserAnimationsModule,
    FollowModule,
    NgbModule,
    HttpClientModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot(effects),
    NgDragDropModule.forRoot(),
    NgProgressModule,
    SupplierPortalModule,
    NgProgressHttpModule
    // StoreDevtoolsModule.instrument({
    // maxAge: 8
    // })
  ],
  declarations: [
    LayoutComponent,
    HeaderComponent,
    ModalQueryFilter,
    FooterComponent,
    FlashComponent,
    ProformaWeightedFobModalComponent,
    ProductDisabledFobComponent
  ],
  entryComponents: [
    FlashComponent,
    ProductDisabledFobComponent,
    ProformaWeightedFobModalComponent,
    ModalQueryFilter,
    FollowIdComponent
  ],
  providers: [
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  exports: [LayoutComponent]
})
export class CoreModule {}
